export const applyWrapperToSelection = (
  value,
  selectionStart,
  selectionEnd,
  before,
  after = before,
) => {
  const selected = value.slice(selectionStart, selectionEnd);
  const wrapped = `${before}${selected}${after}`;
  const nextValue =
    value.slice(0, selectionStart) + wrapped + value.slice(selectionEnd);

  return {
    nextValue,
    selectionStart: selectionStart + before.length,
    selectionEnd: selectionStart + before.length + selected.length,
  };
};

export const insertLinkAtSelection = (
  value,
  selectionStart,
  selectionEnd,
  label,
  url,
) => {
  const insertion = `[${label}](${url})`;
  const nextValue =
    value.slice(0, selectionStart) + insertion + value.slice(selectionEnd);

  return {
    nextValue,
    selectionStart: selectionStart + insertion.length,
    selectionEnd: selectionStart + insertion.length,
  };
};

export const normalizeChatLinkUrl = (url) => {
  const trimmed = String(url || "").trim();
  if (!trimmed) {
    return "";
  }

  if (/^https?:\/\//i.test(trimmed)) {
    return trimmed;
  }

  return `https://${trimmed}`;
};

export const isSafeChatLinkHref = (href) => {
  try {
    const url = new URL(href);
    return url.protocol === "http:" || url.protocol === "https:";
  } catch {
    return false;
  }
};

export const prepareChatMarkdownForRender = (text) => {
  if (!text) {
    return "";
  }

  return text.replace(/\n/g, "  \n");
};

export const stripChatMarkdown = (text) => {
  if (!text) {
    return "";
  }

  return text
    .replace(/\[([^\]]+)\]\([^)]+\)/g, "$1")
    .replace(/\*\*([^*]+)\*\*/g, "$1")
    .replace(/\*([^*]+)\*/g, "$1")
    .replace(/~~([^~]+)~~/g, "$1");
};
